import YearView from "./YearView.js";
import WeekView from "./WeekView.js";

export default function Board({ view, birthday, expected }) {
  return view === "years" ? (
    <YearView birthday={birthday} expected={expected} />
  ) : (
    <WeekView birthday={birthday} expected={expected} />
  );
}
